import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getMatchAccaConfig() {
    return {
        palette: {
            [PALETTE_IDS.MATCH_ACCA]: {
                MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_TEXT: COLOR.BRAND.FOREGROUND1,
                MATCH_ACCA_SELECTIONS_BAR_BORDER: {
                    BORDER_COLOR: COLOR.BRAND.BACKGROUND1,
                },
            },
            [PALETTE_IDS.MARKET_INSTRUCTIONS]: {
                MARKET_INSTRUCTIONS_BET_BUILDER_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.MATCH_ACCA_SLIP]: {
                MATCH_ACCA_SLIP_SELECTION_BORDER_RADIUS: 0,
                MATCH_ACCA_SLIP_SELECTION_SEPARATOR_ICON_COLOR: COLOR.BRAND.BACKGROUND5,
                MATCH_ACCA_SLIP_ONBOARDING_SELECTION_NAME_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
            },
        },
    };
}
